import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The royal hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a warm rose + gold storybook palette pulled from
 * her painted art, with a soft lavender-dusk sky (her own world). Choosing her recolours the WHOLE kid shell:
 * the brand ramp drives buttons / meters / rings in rose, the canvas blooms warm to a rose+gold dawn, and the
 * hero stage takes her lavender-pink dusk. Every brand colour is paired with its own foreground for legibility.
 */
export const royalTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — rose. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light text
  // (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #C14986 for coloured shadows.
  '--color-primary': '#C14986',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#D475A4',
  '--color-primary-deep': '#8E3A63',
  '--color-primary-tint': '#F9E4EF',
  '--color-primary-glow-rgb': '193 73 134',
  '--color-secondary': '#F6DCEC',
  '--color-secondary-fg': '#5A2746',
  '--color-accent': '#F2C14E',
  '--color-accent-fg': '#4A3A00',
  // CANVAS — a rose bloom top-left, a soft-gold bloom bottom-right (a warm storybook dawn behind the content).
  '--canvas-a': '#FBE3F1',
  '--canvas-b': '#FCEFD8',
  // A soft lavender-pink storybook dusk (white text stays AA over it).
  '--sky-top': '#3a2a5e',
  '--sky-mid': '#6b4f9e',
  '--sky-low': '#c79bd8',
  '--sky-glow': '#ffe2c8',
  '--sky-fg': '#ffffff',
});
